export const ROUTE_PAGE = {
  SIGNIN: "/dang-nhap",
  SIGNUP: "/dang-ky",
};
